import { useRef } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import MSCProjects from './components/Pages/MScProjects';
import ResearchProjects from './components/Pages/ResearchProjects';
import UnderGProjects from './components/Pages/UnderGProjects';
import Courses from './components/Pages/Courses';
import Papers from './components/Pages/Papers';
import { Layout, Home } from './components/Pages/Home';

import { BASE_NAME } from './routes';

function App() {

  const researchLineRef = useRef(null);
  const aboutRef = useRef(null);
  const coursesRef = useRef(null);

  return (
    <Router basename={BASE_NAME}>
      <Layout researchLineRef={researchLineRef} aboutRef={aboutRef} coursesRef={coursesRef}>
        <Routes>
          <Route exact path="/" element={<Home researchLineRef={researchLineRef} aboutRef={aboutRef} coursesRef={coursesRef}/>} />
          <Route path="/research-projects" element={<ResearchProjects/>} />
          <Route path="/msc-projects" element={<MSCProjects />} />
          <Route path="/undergrad-projects" element={<UnderGProjects />} />
          <Route path="/courses" element={<Courses />} /> 
          <Route path="/research-papers" element={<Papers />} />
          {/* <Route component={NotFound} /> */}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
